import React, { Component } from 'react'
import moment from 'moment'
import {SingleDatePicker} from 'react-dates'
import { QueryService } from 'services/queries'
import ErrorType from 'services/ErrorType'
import config from 'services/config'
import MoneyValue from 'components/MoneyValue'

import 'react-dates/lib/css/_datepicker.css'

//import jQuery from 'services/jQueryDatatablesBootstrap'
import { BootstrapTable, TableHeaderColumn, ExportCSVButton } from 'react-bootstrap-table';
import 'react-bootstrap-table/dist/react-bootstrap-table-all.min.css';

import Spinner from 'react-spinkit'

let _moneyFormat = value => (<MoneyValue value={value}/>)
let _dateFormat = date => moment(date).format('M/D/YYYY')
let _humanize = s => {
  return s ? s.replace(/_/g, ' ').trim().replace(/([^\s])([A-Z])/g, '$1 $2').replace(/\b[A-Z][a-z]+\b/g, function (x) {
    return x.toLowerCase();
  }).replace(/^[a-z]/g, function (x) {
    return x.toUpperCase();
  }) : null;
};
let _balanceTypeFormat = s => s.includes('[')
                                ? s.replace(/_/g, ' ').replace(/TopHatter/, 'Tophatter')
                                : _humanize(s)


class SearchResultsTable extends Component {

  render() {

    return (
      <div className="card">
        <div className="card-body">
          { (this.props.loading) && <Spinner name='circle' /> }
          <BootstrapTable
            data={this.props.data}
            striped
            pagination
            exportCSV
            csvFileName={'search_' + this.props.search + '_results.csv'}
            search
            options={{
              sizePerPage: 50,
              paginationShowsTotal: true,
              paginationPosition: 'top',
              hideSizePerPage: true,
              defaultSortName: 'post_date',
              defaultSortOrder: 'asc',
              exportCSVBtn: () => <ExportCSVButton className='btn-blue'/>
            }}>
            <TableHeaderColumn dataField="search" hidden export>Search for</TableHeaderColumn>
            <TableHeaderColumn dataField="post_date"             dataSort width="6em" dataFormat={_dateFormat} csvFormat={_dateFormat} dataAlign="right" width="8em">{_humanize('post_date')}</TableHeaderColumn>
            <TableHeaderColumn dataField="effective_date"        dataSort width="6em" dataFormat={_dateFormat} csvFormat={_dateFormat} dataAlign="right" width="8em">{_humanize('effective_date')}</TableHeaderColumn>
            <TableHeaderColumn dataField="activity_type"         dataSort width="8em" dataFormat={_humanize}>{_humanize('activity_type')}</TableHeaderColumn>
            <TableHeaderColumn dataField="transaction_type"      dataSort width="12em" dataFormat={_humanize}>{_humanize('transaction_type')}</TableHeaderColumn>
            <TableHeaderColumn dataField="transaction_name"      dataSort width="12em" dataFormat={_humanize}>{_humanize('transaction_name')}</TableHeaderColumn>
            <TableHeaderColumn dataField="journal"               dataSort width="10em" dataFormat={_humanize} csvFormat={_humanize}>Journal</TableHeaderColumn>
            <TableHeaderColumn dataField="account"               dataSort width="8em">Account</TableHeaderColumn>
            <TableHeaderColumn dataField="balance_type"          dataSort width="13em" dataFormat={_balanceTypeFormat} csvFormat={_balanceTypeFormat}>Balance type</TableHeaderColumn>
            <TableHeaderColumn dataField="currency"              dataSort width="6em">Currency</TableHeaderColumn>
            <TableHeaderColumn dataField="signed_amount"         dataSort width="7em" dataFormat={_moneyFormat} dataAlign="right">Amount</TableHeaderColumn>
            <TableHeaderColumn dataField="signed_amount_usd"     dataSort width="7em" dataFormat={_moneyFormat} dataAlign="right">Amount (USD)</TableHeaderColumn>
            <TableHeaderColumn dataField="activity_id"           dataSort width="8em">{_humanize('activity_id')}</TableHeaderColumn>
            <TableHeaderColumn dataField="transaction_id"        dataSort width="8em" isKey>{_humanize('transaction_id')}</TableHeaderColumn>
            <TableHeaderColumn dataField="activity_reference"    dataSort width="10em">{_humanize('activity_reference')}</TableHeaderColumn>
            <TableHeaderColumn dataField="transaction_reference" dataSort width="10em">{_humanize('transaction_reference')}</TableHeaderColumn>
            <TableHeaderColumn dataField="journalentry_reference" dataSort width="10em">{_humanize('journalentry_reference')}</TableHeaderColumn>
            <TableHeaderColumn dataField="contract"               dataSort width="8em">Contract</TableHeaderColumn>
          </BootstrapTable>
        </div>
      </div>
    )
  }
}


class Search extends Component {

  constructor(props) {
    super(props)
    this.state = {
      search: '',
      summary: [],
      results: [],
      loading: false,
      searchSubmitted: false
    }

    this.onInputChange = this.onInputChange.bind(this)
    this.onSearchKeyPress = this.onSearchKeyPress.bind(this)
    this.fetchSearchResults = this.fetchSearchResults.bind(this)

    if (this.props.location.state && this.props.location.state.search)
      this.state.search = this.props.location.state.search
    this.queryService = new QueryService(this.props.book)

  }

  componentWillMount() {
    this.fetchSearchResults(this.state.search)
  }


  onInputChange(event) {
    const target = event.target;
    this.setState({
      [target.name]: target.value
    });
  }

  onSearchKeyPress(event) {
    if (event.key === 'Enter') {
      console.log('Search: ', this.state.search)
      this.fetchSearchResults(this.state.search)
    }
  }


  async fetchSearchResults(search, limit = null) {
    if (!search) return null
    try {
      this.setState({loading: true, searchSubmitted: true})
      let result = await this.queryService.getSearchResults(search, limit)
      this.setState({
        results: result.results,
        loading: (limit !== null)
      })
    } catch (err) {
      if (err && err.type) {
        if (err.type === ErrorType.Authorization) {
          this.props.history.push(config.loginPage)
          return
        }
      }
      throw err
    }
  }


  render() {
    return (
      <div className="content-wrapper">
        <div className="page-title">
          <div>
            <h1><i className="fa fa-search"></i> Search</h1>
            <p>Type in any ID to see related transactions</p>
          </div>
          <div className="form-inline">
            <label className="header-input">
              <span className="period">Search</span>
              <input className="form-control" name="search" type="text" autoFocus={true}
                     value={this.state.search} onChange={this.onInputChange} onKeyPress={this.onSearchKeyPress} />
            </label>
          </div>
        </div>
          <div className="row small">
            <div className="col-md-12">
              { (this.state.searchSubmitted) &&
                <SearchResultsTable
                  data={this.state.results}
                  search={this.state.search}
                  loading={this.state.loading}
                />
              }
            </div>
          </div>
      </div>
    )
  }
}

export default Search




// WEBPACK FOOTER //
// ./src/containers/Dashboard/Search/index.js